var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "ns-search-results",
      attrs: { "data-testid": "searchTerm", "data-searchTerm": _vm.query },
    },
    [
      _c("div", { staticClass: "crop-container" }, [
        _vm.hasResults
          ? _c(
              "div",
              [
                _c(
                  "NsProductListSortable",
                  {
                    attrs: {
                      "select-placeholder": (_vm.translations.productCard || {})
                        .select,
                      skus: _vm.skus,
                      "sku-search-scores": _vm.skusWithScores,
                      "sort-by-label": _vm.translations.sortBy,
                      "sort-by-options": _vm.translations.sortOptions,
                      "sort-by-selected": _vm.sortBySelected,
                    },
                    on: { "sort-by-select": _vm.handleSortBySelect },
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "woc-heading",
                        attrs: { slot: "woc-heading" },
                        slot: "woc-heading",
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "back-button",
                            on: { click: _vm.back },
                          },
                          [
                            _c("NsIcon", {
                              staticClass: "back-button-icon",
                              attrs: { "icon-name": "icon-angle-left-24" },
                            }),
                            _vm._v(" "),
                            _c("span", { staticClass: "back-button-text" }, [
                              _vm._v(_vm._s(_vm.translations.back)),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c("span", {
                          staticClass: "search-results-text",
                          domProps: {
                            innerHTML: _vm._s(_vm.searchResultsText),
                          },
                        }),
                      ]
                    ),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.hasResults
          ? _c("div", { staticClass: "no-results-body" }, [
              _c("div", { staticClass: "img-container" }, [
                _c("img", {
                  attrs: { src: _vm.localNoResultsImageUrl, alt: "No Results" },
                }),
              ]),
              _vm._v(" "),
              _c("p", {
                staticClass: "no-results-text",
                domProps: { innerHTML: _vm._s(_vm.translations.noResults) },
              }),
              _vm._v(" "),
              _c("p", { staticClass: "search-query" }, [
                _vm._v('"' + _vm._s(_vm.query) + '"'),
              ]),
            ])
          : _vm._e(),
      ]),
      _vm._v(" "),
      !_vm.hasResults
        ? _c(
            "div",
            { staticClass: "no-results-footer" },
            [
              _vm.showSearchResults
                ? _c("NsProductCarousel", { attrs: { type: "popular" } })
                : _vm._e(),
            ],
            1
          )
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }